import React from 'react'
import Skeleton from 'react-loading-skeleton'

import { bemJoin } from 'bem-join'

import { IntlMessageKeys, useIntl } from '@app/intl/Intl'
import { InputField } from '@app/lib/fields/InputField/InputField'
import { Select } from '@app/lib/inputs/Select'
import { useInvoicingFeeTablesContext } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/Components/InvoicingFeeTablesContext/InvoicingFeeTablesContext'

export const LegalPositionSelect = () => {
  const b = bemJoin('court-case-invoicing-form')
  const { formatMessage } = useIntl()
  const { loadingFeeTables, feeTableKeys, setCourtCaseFee } = useInvoicingFeeTablesContext()

  if (loadingFeeTables) {
    return <Skeleton />
  }

  const options = feeTableKeys.map((key) => ({
    value: key,
    label: formatMessage({
      id: `CourtCases.Invoicing.Option.LegalPosition.${key}` as IntlMessageKeys
    })
  }))

  return (
    <InputField
      name='LegalPosition'
      className={b('field', { md: true })}
      label={formatMessage({ id: 'CourtCases.Invoicing.Field.LegalPosition' })}
      render={({ inputProps }) => {
        return (
          <Select
            {...inputProps}
            triggerSize='sm'
            onChange={(value) => {
              inputProps.onChange(value)
              setCourtCaseFee()
            }}
            options={options}
          />
        )
      }}
    />
  )
}
